import React, { useState } from "react";
import Card from "../Card/Card";
import styled from "styled-components";
import theme from "../../theme/theme";

import educationIcon from "../../assets/educationIcon.jpg";
import retirementIcon from "../../assets/retirementIcon.jpg";
import majorPurchaseIcon from "../../assets/majorPurchaseIcon.jpg";
import buildWealthIcon from "../../assets/buildWealthIcon.jpg";
import EditButton from "../EditName/EditButton";
import EditNameModalScreen from "../EditName/EditNameModalScreen";
import { SET_LOADING } from "../../redux/action-types";
import { useDispatch } from "react-redux";

const Wrapper = styled.div`
  width: 100%;

  .cardContentParent {
    .headerRow {
      border-bottom: 1px solid lightgray;
      padding-bottom: 20px;
      display: flex;
      width: 100%;
      justify-content: space-between;
      flex-wrap: wrap;

      @media (max-width: 650px) {
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
      }

      .headerContainer {
        display: flex;
        white-space: nowrap;
        @media (max-width: 480px) {
          width: 100%;
          justify-content: space-between;
          white-space: normal;
          text-align: center;
        }
      }

      .icon {
        margin-right: 10px;
        height: 50px;
        @media (max-width: 480px) {
          margin: auto;
          margin-right: 5px;
        }
      }

      .goalImage {
        height: 100%;
      }

      .goalName {
        width: 40%;
        display: flex;
        align-items: center;
        @media (max-width: 480px) {
          width: 100%;
        }

        .name {
          font-size: 30px;
          color: ${theme.colors.primaryStrong2X};
          // display: flex;
          // align-items: flex-end;
          // flex-wrap: nowrap;
          .goalTitle {
            max-width: 300px;
            overflow: hidden;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            @media (max-width: 480px) {
              width: 100%;
              max-width: 200px;
            }
            @media (max-width: 400px) {
              width: 100%;
              max-width: 150px;
            }
          }

          .date {
            font-size: 12px;
            margin-top: 8px;
          }
        }
      }

      .no {
        font-size: 15px;
        color: ${theme.colors.primaryStrong2X};
      }
    }

    .today {
      .applicationStatusContainer {
        float: right;
        @media (max-width: 650px) {
          float: none;
        }
      }

      .amount {
        font-size: 30px;
        color: black;
        white-space: nowrap;
        text-align: center;
      }
      .text {
        font-size: 15px;
        color: ${theme.colors.primaryStrong2X};
        text-align: center;
      }
    }
  }

  .body {
    margin-top: 20px;
    padding: 0px 30px;
    display: flex;
    padding-bottom: 20px;
    border-bottom: 1px solid lightgray;
    .heading {
      font-size: 12px;
      font-weight: 700;
    }
    .accountDetails {
      width: 50%;
      border-right: 1px solid lightgray;

      .info {
        color: ${theme.colors.primaryStrong2X};
        margin-top: 10px;
        font-size: 12px;
      }
    }

    .topHoldings {
      width: 50%;

      // border-right: 1px solid lightgray;
      padding-left: 30px;
      .info {
        color: ${theme.colors.primaryStrong2X};
        margin-top: 10px;
        font-size: 12px;
      }
    }
    .viewStatement {
      width: 33%;
      padding-left: 30px;
    }
  }

  .footer {
    display: flex;
    width: 100%;
    margin-top: 20px;
    gap: 10px;

    .footerButton {
      width: 50%;
      border: none;
      padding: 20px 0px;
      border-radius: 15px;
      font-size: 20px;
      cursor: pointer;
      @media (max-width: 480px) {
        font-size: 16px;
        padding: 10px;
      }
    }
  }

  .footerOneButton {
    // display: flex;
    width: 100%;
    margin-top: 20px;
    // gap: 10px;
    text-align: center;

    .footerButton {
      width: 50%;
      border: none;
      padding: 20px 0px;
      border-radius: 15px;
      font-size: 20px;
      cursor: pointer;
      @media (max-width: 480px) {
        font-size: 16px;
        padding: 10px;
      }
    }
  }
`;

const GoalCardNonSubmitted = (props) => {
  const [isEditing, setIsEditing] = useState(false);
  const dispatch = useDispatch();

  return (
    <Wrapper>
      {isEditing && (
        <EditNameModalScreen
          id={props.data.goalId}
          isHidden={setIsEditing}
          actualName={props.data.goalTitle}
        />
      )}

      <Card isMarginNeeded={false} isLeftBorderVisible={true}>
        <div className="cardContentParent">
          <div className="headerRow">
            <div className="headerContainer">
              <div className="icon">
                <img
                  className="goalImage"
                  alt="goal type logo"
                  src={
                    props.data.goalType === "Education"
                      ? educationIcon
                      : props.data.goalType === "Retirement"
                      ? retirementIcon
                      : props.data.goalType === "Major Purchase"
                      ? majorPurchaseIcon
                      : props.data.goalType === "Build Wealth"
                      ? buildWealthIcon
                      : ""
                  }
                />
              </div>
              <div className="goalName">
                <div className="name">
                  <div className="goalTitle">
                    {props.data.goalTitle.length <= 19
                      ? props.data.goalTitle
                      : props.data.goalTitle.substring(0, 19) + "..."}
                  </div>
                  <div className="date">
                    Created: {new Date(props.data.createdDate).toDateString()}
                  </div>
                </div>
                <EditButton
                  actionOnClick={() => {
                    setIsEditing(true);
                  }}
                />
                {/* <div className="no">XXXXXXXXXXX 08253</div> */}
              </div>
            </div>
            <div className="today">
              <div className="applicationStatusContainer">
                <div className="amount">
                  {props.status === "NotLinked" ||
                  props.status === "Incomplete" ||
                  props.status === "New Account" ||
                  props.status === "Launched" ||
                  props.status === "New"
                    ? "In Progress"
                    : props.status === "Pending"
                    ? "Waiting Approval"
                    : props.status}
                </div>
                <div className="text">Application Status</div>
              </div>
            </div>
          </div>
          {props.status === "NotLinked" ||
          props.status === "Incomplete" ||
          props.status === "New Account" ||
          props.status === "Launched" ||
          props.status === "Pending" ? (
            <div className="footer">
              {!props.isIbkrStatusAvailable ||
              props.status === "Abandoned" ||
              props.status === "Closed" ||
              props.status === "Rejected" ? (
                <button
                  className="footerButton"
                  onClick={() => {
                    props.deleteGoal(props.data?.goalId, props.data?.goalType);
                  }}
                >
                  Delete
                </button>
              ) : (
                <button
                  className="footerButton"
                  onClick={() =>
                    props.handleContactAdvisorClick(props.data.goalId)
                  }
                >
                  Contact Advisor
                </button>
              )}
              <button
                style={{ margin: props.isIbkrStatusAvailable ? "auto" : "" }}
                className="footerButton"
                onClick={() => {
                  if (props.isIbkrStatusAvailable) {
                    props.manageAccountClick(props.data.goalId);
                  } else {
                    dispatch({ type: SET_LOADING, payload: true });
                    props.applicationStatusOnClick(props.data.goalId);
                  }
                }}
              >
                Continue
              </button>
            </div>
          ) : props.status === "Abandoned" ||
            props.status === "Closed" ||
            props.status === "Rejected" ? (
            <div className="footer">
              <button
                className="footerButton"
                onClick={() => {
                  props.deleteGoal(props.data?.goalId, props.data?.goalType);
                }}
              >
                Delete
              </button>
              <button
                style={{ margin: props.isIbkrStatusAvailable ? "auto" : "" }}
                className="footerButton"
                onClick={() => {
                  if (props.isIbkrStatusAvailable) {
                    props.manageAccountClick(props.data.goalId);
                  } else {
                    dispatch({ type: SET_LOADING, payload: true });
                    props.applicationStatusOnClick(props.data.goalId);
                  }
                }}
              >
                Continue
              </button>
            </div>
          ) : (
            <div className="footerOneButton">
              <button
                className="footerButton"
                onClick={() =>
                  props.handleContactAdvisorClick(props.data.goalId)
                }
              >
                Contact Advisor
              </button>
              {/* <button
                className="footerButton"
                onClick={() =>
                  props.applicationStatusOnClick(props.data.goalId)
                }
              >
                View Application Status
              </button> */}
            </div>
          )}
        </div>
      </Card>
    </Wrapper>
  );
};

export default GoalCardNonSubmitted;
